import { render, staticRenderFns } from "./TabelaColaboradores.vue?vue&type=template&id=265bab08&scoped=true&"
import script from "./TabelaColaboradores.vue?vue&type=script&lang=js&"
export * from "./TabelaColaboradores.vue?vue&type=script&lang=js&"
import style0 from "./TabelaColaboradores.vue?vue&type=style&index=0&id=265bab08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265bab08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VSpacer,VToolbar,VToolbarTitle})
